import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slidesContainer", "indicator", "video"];

  connect() {
    this.currentSlide = 0;
    this.totalSlides = 3; // Fewer slides for sign-in page
    this.startAutoSlide();
  }

  disconnect() {
    if (this.autoSlideTimer) {
      clearInterval(this.autoSlideTimer);
    }
  }

  startAutoSlide() {
    // Auto-advance slides every 4 seconds
    this.autoSlideTimer = setInterval(() => {
      this.nextSlide();
    }, 4000);
  }

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
    this.updateSlider();
  }

  updateSlider() {
    // Update slide position
    const offset = -this.currentSlide * 100;
    this.slidesContainerTarget.style.transform = `translateX(${offset}%)`;

    // Update indicators
    this.indicatorTargets.forEach((indicator, index) => {
      if (index === this.currentSlide) {
        indicator.classList.remove("bg-gray-600", "w-2");
        indicator.classList.add("bg-white", "w-8");
      } else {
        indicator.classList.remove("bg-white", "w-8");
        indicator.classList.add("bg-gray-600", "w-2");
      }
    });

    // Restart videos when slide becomes active
    if (this.hasVideoTarget) {
      this.videoTargets.forEach((video, index) => {
        if (index === this.currentSlide) {
          video.currentTime = 0;
          video.play();
        } else {
          video.pause();
        }
      });
    }
  }
}